import { Component, Input } from '@angular/core';
import { IDesignerValidationError } from '../designer-config-service/designer-config.service';


@Component({
    selector: 'app-designer-validation-errors',
    templateUrl: './designer-validation-errors.component.html',
    styleUrls: ['./designer-validation-errors.component.scss'],
    standalone: false
})
export class DesignerValidationErrorsComponent {
  errors: string[];
  warnings: string[];

  @Input() set validationErrors(value: IDesignerValidationError[]) {
    this.errors = [];
    if (value) {
      this.errors = value.map(e => {
        let es = '';
        if (e.source && e.source.length) {
          es = e.source.reverse().map(t => `${t.configType} ${t.configId}`).join(' -> ') + ':';
        }
        return `${es} ${e.message}`;
      });
    }
  }

  @Input() set validationWarnings(value: IDesignerValidationError[]) {
    this.warnings = [];
    if (value) {
      this.warnings = value.map(e => {
        let es = '';
        if (e.source && e.source.length) {
          es = e.source.reverse().map(t => `${t.configType} ${t.configId}`).join(' -> ') + ':';
        }
        return `${es} ${e.message}`;
      });
    }
  }
}
